import axios from "axios";
import { getValidToken } from "../../../utils/authUtils";
import { FuelCardType } from "./types";

export const fuelCardApiService = {
  getFuelCard: async () => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}master-data/fuel-cards`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      }
      return [];
    } catch (error) {
      return [];
    }
  },

  createFuelCard: async (fuelCard: FuelCardType) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}master-data/fuel-cards`;
      const response = await axios.post(url, fuelCard, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      }
      return null;
    } catch (error) {
      return null;
    }
  },

  updateFuelCard: async (fuelCard: FuelCardType) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}master-data/fuel-cards/${fuelCard.id}`;
      const response = await axios.put(url, fuelCard, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      }
      return null;
    } catch (error) {
      return null;
    }
  },

  search: async (term: string, vehicleNumber: string) => {
    try {
      const searchQuery = vehicleNumber
        ? `provider=${encodeURIComponent(
            term
          )}&vehicleNumber=${encodeURIComponent(vehicleNumber)}`
        : `provider=${encodeURIComponent(term)}`;
      const token = await getValidToken();
      const url = `${
        process.env.REACT_APP_API_HOST
      }master-data/fuel-cards?${searchQuery}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      }
      return [];
    } catch (error) {
      return [];
    }
  },
};
